import { useBerichtenProlongatiewijzigingenVoorPakketVersieOphalen } from '@services/communicatie-public/orval-api/berichten-api/berichten-api';
import { computed, toRef, toValue, type MaybeRefOrGetter } from 'vue';
import { usePakketten } from './pakketten';
import { useRouteRelatienummer } from './route-relatienummer';

export function useProlongatieHistorie(
  polisnummer: MaybeRefOrGetter<string | undefined>,
  prolongatieJaar: MaybeRefOrGetter<number | undefined>,
  options?: {
    enabled?: MaybeRefOrGetter<boolean | undefined>;
  },
) {
  const getPakketten = usePakketten({ enabled: options?.enabled });
  const relatienummer = useRouteRelatienummer();

  const pakket = computed(() =>
    getPakketten.data.value?.pakketten.find(
      ({ pakketPolisnummer }) => pakketPolisnummer === toValue(polisnummer),
    ),
  );

  return useBerichtenProlongatiewijzigingenVoorPakketVersieOphalen(
    toRef(polisnummer),
    computed(() => ({
      cvvMaand: pakket.value?.cvvMaand,
      prolongatieJaar: toValue(prolongatieJaar),
      relatienummer: relatienummer.value,
    })),
    {
      query: {
        ...options,
        select: ({ result }) => result,
      },
    },
  );
}
